import React, { useEffect, useState } from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CollapsableComponentProps {
  label: string;
  disableCollapsing?: boolean;
  children: React.ReactNode;
  defaultOpen?: boolean;
  onToggle?: (open: boolean) => void;
}

export const CollapsableComponent = ({
  label,
  disableCollapsing = false,
  children,
  defaultOpen = false,
  onToggle
}: CollapsableComponentProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const handleToggle = () => {
    setOpen((prev) => {
      const next = !prev;
      onToggle?.(next);
      return next;
    });
  };

  return (
    <Box id="index__components-collapsible-section__box__l35"
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box'
    }}>
      
      <div id="index__components-collapsible-section__div__l43" style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '3px' }}>
        <Typography id="index__components-collapsible-section__typography__l44" fontSize={'14px'} sx={{ cursor: 'pointer' }} onClick={handleToggle}>
          {label}
        </Typography>
        {!disableCollapsing &&
        <IconButton id="index__components-collapsible-section__iconbutton__l48" onClick={handleToggle}>
            <ExpandMoreIcon
            sx={{
              transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: 'transform 0.3s ease'
            }} />
          
          </IconButton>
        }
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit sx={{ boxSizing: 'border-box' }}>
        <Box id="index__components-collapsible-section__box__l59"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box'
        }}>
          
          {children}
        </Box>
      </Collapse>
    </Box>);

};